export var global = typeof window !== 'undefined' ? window : {};



//////////////////
// WEBPACK FOOTER
// /Users/jordan/www/sites/chryso/wwwroot/wp-content/themes/chryso-v2/node_modules/@juggle/resize-observer/lib/utils/global.js
// module id = 139
// module chunks = 0